import { useMemo, useRef } from 'react';
export default function useTouchDetection(_ref) {
  var condition = _ref.condition,
      onStart = _ref.onStart,
      onMove = _ref.onMove,
      onEnd = _ref.onEnd;
  var touched = useRef(false);
  var touchEvents = useMemo(function () {
    return condition ? {
      onTouchStart: function onTouchStart(event) {
        if (onStart) {
          onStart(event);
        }

        touched.current = true;
      },
      onTouchMove: function onTouchMove(event) {
        if (onMove) {
          onMove(event);
        }

        touched.current = false;
      },
      onTouchEnd: function onTouchEnd(event) {
        if (onEnd) {
          onEnd(event, touched.current);
        }

        touched.current = false;
      }
    } : {};
  }, [condition, onStart, onMove, onEnd]);
  return [touchEvents, touched];
}